import { NSARouterMakerResult } from "namirasoft-account-react";
import { Component } from "react";
import { InferenceEntities } from "../InferenceEntities";
import { InferenceInfo } from "../InferenceInfo";
import { InferenceLayout } from '../InferenceLayout';
import { InferenceRouterProps } from "../InferenceRouterProps";

interface WiperViewPageProps extends NSARouterMakerResult, InferenceRouterProps { }

export default class WiperViewPage extends Component<WiperViewPageProps>
{
    override render()
    {
        return (
            <InferenceLayout
                {...this.props}
                action={{ description: InferenceInfo.wiper.view }}
                pages={{
                    entity: InferenceEntities.wiper(this.props),
                    view: {}
                }}
            >
                <></>
            </InferenceLayout>
        );
    }
}